import { Button, Typography } from "@mui/material"
import { styled } from '@mui/system';

import { useTranslation } from "react-i18next";
import notInPilotIcon from "../../assets/notInPilot.svg"
import GenericDialog from "./GenericDIalog";

const OLD_PORTAL = "https://flpnwc-a7e44169a.dispatcher.hana.ondemand.com/sites/houshold?sap-language=iw"

export const GreenButton = styled(Button)(({ theme }) => ({
    "&:hover": {
        background: '#cee2cd !important',
    },
    backgroundColor: '#3a7735 !important',
    color: "#ffffff !important",
    alignItems: 'center !important',
    justifyContent: 'center !important',
    margin: '1rem !important',
    borderRadius: '50px !important',
    width: '10.75rem !important',
    textTransform: "capitalize !important",

    // Disabled state styles
    "&.Mui-disabled": {
        backgroundColor: '#c0c0c0 !important',
        color: '#ffffff !important',
        cursor: 'not-allowed !important',
        opacity: 1 // override MUI's default opacity for disabled buttons
    }
}));


const NotInPilotModal = ({ open, setOpen }) => {
    const { t } = useTranslation()
    const navToOldPortal = (event) => {
        window.location.replace(OLD_PORTAL)
    };
    return (
        <GenericDialog open={open} setOpen={setOpen} iconSVG={notInPilotIcon} showRopes={true} height="23rem">
            <Typography color="#064601" variant="mediumBoldText">{t('notInPilotTitle')}</Typography>
            <Typography color="#064601" >{t('notInPilotText')}</Typography>
            <Typography color="#064601" mb="3rem">{t('notInPilotText2')} </Typography>
            <GreenButton onClick={navToOldPortal}>{t('toOldPortal')}</GreenButton>
        </GenericDialog>

    )
}
export default NotInPilotModal;
